"use client";

import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { usePreloader } from "@/context/PreloaderContext";

export default function Preloader() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showContent, setShowContent] = useState(true);
  const { setIsExiting, setIsFinished } = usePreloader();

  useEffect(() => {
    // Блокируем скролл при активном прелоадере
    document.body.style.overflow = "hidden";

    const handleLoad = () => {
      // Искусственная задержка 2 секунды
      setTimeout(() => {
        setIsLoaded(true);
        setIsExiting(true); // Уведомляем Hero, что начинаем уходить
        // Разблокируем скролл после завершения анимации шторки
        setTimeout(() => {
          document.body.style.overflow = "auto";
          setShowContent(false);
          setIsFinished(true);
        }, 1500); // 0.5s (fade out letters) + 1.0s (shutter move)
      }, 2000);
    };

    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      return () => window.removeEventListener("load", handleLoad);
    }
  }, [setIsExiting, setIsFinished]);

  if (!showContent) return null;

  const text = "WWW.TST.MD";
  const letters = text.split("");

  return (
    <motion.div
      initial={{ y: 0 }}
      animate={isLoaded ? { y: "-100%" } : { y: 0 }}
      transition={{ 
        duration: 1.0, 
        ease: [0.7, 0, 0.3, 1], 
        delay: 0.5 
      }}
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#0F172A]"
    >
      <AnimatePresence mode="wait">
        {!isLoaded && (
          <motion.div
            key="text-container"
            exit={{ 
              opacity: 0, 
              scale: 1.05,
              transition: { duration: 0.4, ease: "easeOut" }
            }}
            className="flex items-center justify-center space-x-[0.2em]"
          >
            {letters.map((char, i) => (
              <motion.span
                key={i}
                initial={{ opacity: 0 }}
                animate={{ 
                  opacity: [0.4, 1, 0.4],
                }}
                transition={{
                  duration: 2.5, 
                  repeat: Infinity, 
                  ease: "easeInOut",
                  delay: i * 0.08
                }}
                className="text-4xl md:text-6xl font-sans font-extrabold tracking-[0.1em] text-white uppercase select-none"
                style={{
                  fontFamily: "var(--font-plus-jakarta)",
                  textShadow: "0 0 20px rgba(59, 130, 246, 0.6)",
                }}
              >
                {char}
              </motion.span>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
